/**
 * AGROMX Frontend - Usuarios List View
 * Vista de administración de usuarios
 */

import usuarioService from '../services/usuario.service.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  data: {
    usuarios: [],
    loading: true,
    editingUsuario: null,
    filters: {
      search: '',
      rol: '',
      activo: ''
    },
    stats: {
      total: 0,
      activos: 0,
      inactivos: 0,
      porRol: []
    },
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0
    }
  },

  async render() {
    // Roles dinámicos desde la BD (sistema de roles del módulo admin).
    // Antes era una lista hardcoded de 8 roles, no reflejaba los roles
    // custom creados por admin.
    const roles = await usuarioService.getRoles();
    const rolesOptions = roles.map(r => `<option value="${r.value}">${r.label}</option>`).join('');

    return `
      <div class="page-header">
        <h1>Gestión de Usuarios</h1>
        ${permisos.canCreate('usuarios') ? `
          <button class="btn btn-primary" id="btnNuevoUsuario">
            + Nuevo Usuario
          </button>
        ` : ''}
      </div>

      <!-- Estadísticas -->
      <div class="stats-grid" id="statsContainer">
        <div class="stat-card">
          <div class="stat-icon">👥</div>
          <div class="stat-content">
            <div class="stat-value" id="statTotal">-</div>
            <div class="stat-label">Total Usuarios</div>
          </div>
        </div>
        <div class="stat-card stat-success">
          <div class="stat-icon">✅</div>
          <div class="stat-content">
            <div class="stat-value" id="statActivos">-</div>
            <div class="stat-label">Activos</div>
          </div>
        </div>
        <div class="stat-card stat-warning">
          <div class="stat-icon">⏸️</div>
          <div class="stat-content">
            <div class="stat-value" id="statInactivos">-</div>
            <div class="stat-label">Inactivos</div>
          </div>
        </div>
      </div>

      <!-- Filtros -->
      <div class="filters-card">
        <div class="filters-grid">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="searchInput"
              class="form-control"
              placeholder="Nombre, email o username..."
            />
          </div>
          <div class="form-group">
            <label class="form-label">Rol</label>
            <select id="rolFilter" class="form-control">
              <option value="">Todos los roles</option>
              ${rolesOptions}
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="activoFilter" class="form-control">
              <option value="">Todos</option>
              <option value="true">Activos</option>
              <option value="false">Inactivos</option>
            </select>
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" id="btnLimpiarFiltros">Limpiar</button>
          </div>
        </div>
      </div>

      <!-- Tabla de usuarios -->
      <div class="card">
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Usuario</th>
                <th class="tbl-hide-mobile">Email</th>
                <th class="tbl-hide-mobile">Rol</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Último acceso</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="usuariosTableBody">
              <tr>
                <td colspan="7" class="text-center">
                  <div class="loading-spinner"></div>
                  Cargando usuarios...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div class="pagination-container" id="paginationContainer"></div>
      </div>

      <!-- Modal Crear/Editar Usuario -->
      <div id="usuarioModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 id="modalTitle">Nuevo Usuario</h2>
            <button class="modal-close" id="btnCerrarModal">&times;</button>
          </div>
          <form id="usuarioForm">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label required">Username *</label>
                  <input
                    type="text"
                    id="inputUsername"
                    class="form-control"
                    placeholder="nombre.apellido"
                    pattern="[a-zA-Z0-9_.]+"
                    required
                  />
                  <small class="form-help">Solo letras, números, puntos y guiones bajos (ej. joselyn.prueba)</small>
                </div>
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <input
                    type="email"
                    id="inputEmail"
                    class="form-control"
                    placeholder="usuario@agromx.com (opcional)"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group" id="groupTipoPersona">
                  <label class="form-label required">Tipo de persona *</label>
                  <select id="inputTipoPersona" class="form-control" required>
                    <option value="">Seleccionar tipo...</option>
                    <option value="fisica">Física</option>
                    <option value="moral">Moral</option>
                  </select>
                </div>
                <div class="form-group" id="groupNombreCompletoEdit" style="display: none;">
                  <label class="form-label" id="labelNombreCompletoEdit">Nombre completo</label>
                  <input
                    type="text"
                    id="inputNombreCompletoEdit"
                    class="form-control"
                    readonly
                    style="background: var(--gray-50);"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label required">Rol *</label>
                  <select id="inputRol" class="form-control" required>
                    <option value="">Seleccionar rol...</option>
                    ${rolesOptions}
                  </select>
                </div>
              </div>

              <!-- Bloque persona física -->
              <div id="bloqueFisica" style="display: none;">
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label required">Nombre *</label>
                    <input type="text" id="inputNombreFisica" class="form-control" placeholder="Juan" />
                  </div>
                  <div class="form-group">
                    <label class="form-label required">Apellido paterno *</label>
                    <input type="text" id="inputApellidoPaterno" class="form-control" placeholder="Pérez" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label required">Apellido materno *</label>
                    <input type="text" id="inputApellidoMaterno" class="form-control" placeholder="García" />
                  </div>
                </div>
              </div>

              <!-- Bloque persona moral -->
              <div id="bloqueMoral" style="display: none;">
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label required">Razón social *</label>
                    <input type="text" id="inputRazonSocial" class="form-control" placeholder="AgroMX S.A. de C.V." />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label required">Teléfono *</label>
                  <input
                    type="tel"
                    id="inputTelefono"
                    class="form-control"
                    placeholder="5512345678"
                    pattern="[0-9]{10}"
                    maxlength="10"
                    inputmode="numeric"
                    oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                    required
                  />
                  <small class="form-help">Exactamente 10 dígitos, solo números</small>
                </div>
              </div>
              <div id="passwordInfo" class="alert alert-info" style="display: none;">
                <strong>Nota:</strong> Se generará una contraseña temporal automáticamente.
              </div>
              <div id="smsOptionWrap" class="form-group" style="display: none;">
                <label style="display:flex;align-items:center;gap:0.5rem;cursor:pointer;">
                  <input type="checkbox" id="enviarSmsCheckbox" checked />
                  <span>Enviar contraseña por SMS al usuario</span>
                </label>
                <small class="form-help">Si lo desactivas, la contraseña solo se mostrará en pantalla para compartirla manualmente.</small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="btnCancelar">Cancelar</button>
              <button type="submit" class="btn btn-primary" id="btnGuardar">Guardar</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Contraseña Temporal -->
      <div id="passwordModal" class="modal" style="display: none;">
        <div class="modal-content modal-sm">
          <div class="modal-header">
            <h2>Contraseña Temporal</h2>
            <button class="modal-close" id="btnCerrarPassword">&times;</button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <strong>¡Importante!</strong> Guarde esta contraseña. Solo se mostrará una vez.
            </div>
            <div class="password-display">
              <code id="tempPasswordDisplay" class="password-code"></code>
              <button type="button" class="btn btn-sm btn-secondary" id="btnCopyPassword" title="Copiar">
                Copiar
              </button>
            </div>
            <div id="smsStatusDisplay" style="margin-top: 0.75rem; padding: 0.6rem 0.85rem; border-radius: 6px; font-size: 0.85rem; display: none;"></div>
            <p class="text-muted mt-2" id="smsStatusHelp">
              Comunique esta contraseña al usuario de forma segura.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" id="btnAceptarPassword">Entendido</button>
          </div>
        </div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('usuarios')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    // Exponer vista globalmente para los event handlers
    window.usuariosView = this;

    // Cargar datos iniciales
    await this.cargarEstadisticas();
    await this.cargarUsuarios();

    // Configurar event listeners
    this.setupEventListeners();
  },

  setupEventListeners() {
    // Botón nuevo usuario
    document.getElementById('btnNuevoUsuario')?.addEventListener('click', () => {
      this.abrirModal();
    });

    // Cerrar modal
    document.getElementById('btnCerrarModal')?.addEventListener('click', () => {
      this.cerrarModal();
    });
    document.getElementById('btnCancelar')?.addEventListener('click', () => {
      this.cerrarModal();
    });

    // Submit formulario
    document.getElementById('usuarioForm')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.guardarUsuario();
    });

    // Filtros
    let searchTimeout;
    document.getElementById('searchInput')?.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.data.filters.search = e.target.value;
        this.data.pagination.page = 1;
        this.cargarUsuarios();
      }, 500);
    });

    document.getElementById('rolFilter')?.addEventListener('change', (e) => {
      this.data.filters.rol = e.target.value;
      this.data.pagination.page = 1;
      this.cargarUsuarios();
    });

    document.getElementById('activoFilter')?.addEventListener('change', (e) => {
      this.data.filters.activo = e.target.value;
      this.data.pagination.page = 1;
      this.cargarUsuarios();
    });

    document.getElementById('btnLimpiarFiltros')?.addEventListener('click', () => {
      this.limpiarFiltros();
    });

    // Modal de contraseña
    document.getElementById('btnCerrarPassword')?.addEventListener('click', () => {
      this.cerrarModalPassword();
    });
    document.getElementById('btnAceptarPassword')?.addEventListener('click', () => {
      this.cerrarModalPassword();
    });
    document.getElementById('btnCopyPassword')?.addEventListener('click', () => {
      this.copiarPassword();
    });

    // Cerrar modales al hacer click fuera
    document.getElementById('usuarioModal')?.addEventListener('click', (e) => {
      if (e.target.id === 'usuarioModal') this.cerrarModal();
    });
    document.getElementById('passwordModal')?.addEventListener('click', (e) => {
      if (e.target.id === 'passwordModal') this.cerrarModalPassword();
    });
  },

  async cargarEstadisticas() {
    try {
      const response = await usuarioService.getStats();
      this.data.stats = response.stats;
      this.renderEstadisticas();
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  renderEstadisticas() {
    document.getElementById('statTotal').textContent = this.data.stats.total || 0;
    document.getElementById('statActivos').textContent = this.data.stats.activos || 0;
    document.getElementById('statInactivos').textContent = this.data.stats.inactivos || 0;
  },

  async cargarUsuarios() {
    try {
      this.data.loading = true;
      const tbody = document.getElementById('usuariosTableBody');
      tbody.innerHTML = `
        <tr>
          <td colspan="6" class="text-center">
            <div class="loading-spinner"></div>
            Cargando usuarios...
          </td>
        </tr>
      `;

      const params = {
        page: this.data.pagination.page,
        limit: this.data.pagination.limit,
        ...this.data.filters
      };

      // Eliminar parámetros vacíos
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === undefined) {
          delete params[key];
        }
      });

      const response = await usuarioService.list(params);
      this.data.usuarios = response.data || [];
      this.data.pagination = response.pagination || this.data.pagination;

      this.renderTabla();
      this.renderPaginacion();
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      const tbody = document.getElementById('usuariosTableBody');
      tbody.innerHTML = `
        <tr>
          <td colspan="6" class="text-center text-danger">
            Error al cargar usuarios: ${error.message || 'Error desconocido'}
          </td>
        </tr>
      `;
    } finally {
      this.data.loading = false;
    }
  },

  renderTabla() {
    const tbody = document.getElementById('usuariosTableBody');

    if (!this.data.usuarios || this.data.usuarios.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="6" class="text-center text-muted">
            No se encontraron usuarios
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = this.data.usuarios.map(usuario => {
      const rolBadge = `<span class="badge ${usuarioService.getRolBadgeClass(usuario.rol)}">${usuarioService.formatRol(usuario.rol)}</span>`;
      const estadoBadge = `<span class="badge ${usuario.activo ? 'badge-success' : 'badge-secondary'}">${usuario.activo ? 'Activo' : 'Inactivo'}</span>`;
      // Si el usuario está inactivo, ocultar editar y resetear contraseña.
      // El admin debe activarlo primero antes de hacer cualquier otra acción.
      const accionesHtml = `
        ${(usuario.activo && permisos.canEdit('usuarios')) ? `<button class="btn-icon btn-edit" onclick="usuariosView.editarUsuario(${usuario.id})" title="Editar">✏️</button>` : ''}
        ${(usuario.activo && permisos.can('usuarios', 'resetear_password')) ? `<button class="btn-icon btn-warning" onclick="usuariosView.resetearPassword(${usuario.id})" title="Resetear contraseña">🔑</button>` : ''}
        ${permisos.canView('usuarios') ? `<button class="btn-icon btn-secondary" onclick="router.navigate('/admin/usuarios/${usuario.id}/permisos')" title="Rol y permisos">🛡️</button>` : ''}
        ${permisos.can('usuarios', 'cambiar_estado') ? `<button class="btn-icon ${usuario.activo ? 'btn-secondary' : 'btn-success'}" onclick="usuariosView.toggleActivo(${usuario.id})" title="${usuario.activo ? 'Desactivar' : 'Activar'}">${usuario.activo ? '⏸️' : '▶️'}</button>` : ''}
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="usuariosView.toggleRow(${usuario.id})">&#9654;</button></td>
        <td>
          <div class="user-info">
            <div class="user-name">${usuario.nombre_completo}</div>
            <div class="user-username text-muted">@${usuario.username}</div>
          </div>
        </td>
        <td class="tbl-hide-mobile">${usuario.email || '-'}</td>
        <td class="tbl-hide-mobile">${rolBadge}</td>
        <td class="tbl-hide-mobile">${estadoBadge}</td>
        <td class="tbl-hide-mobile text-muted">${usuarioService.formatDate(usuario.ultimo_acceso)}</td>
        <td class="tbl-hide-mobile">
          <div class="action-buttons">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-usr-${usuario.id}">
        <td colspan="7" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Email</dt><dd>${usuario.email || '-'}</dd>
            <dt>Rol</dt><dd>${rolBadge}</dd>
            <dt>Estado</dt><dd>${estadoBadge}</dd>
            <dt>Último acceso</dt><dd>${usuarioService.formatDate(usuario.ultimo_acceso)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-usr-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  renderPaginacion() {
    const container = document.getElementById('paginationContainer');
    const { page, totalPages, total } = this.data.pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }

    container.innerHTML = `
      <div class="pagination">
        <button
          class="pagination-btn"
          ${page === 1 ? 'disabled' : ''}
          onclick="usuariosView.cambiarPagina(${page - 1})"
        >
          ← Anterior
        </button>
        <div class="pagination-pages">
          ${pages.map(p => p === '...'
            ? '<span class="pagination-ellipsis">...</span>'
            : `<button
                class="pagination-page ${p === page ? 'active' : ''}"
                onclick="usuariosView.cambiarPagina(${p})"
              >${p}</button>`
          ).join('')}
        </div>
        <button
          class="pagination-btn"
          ${page === totalPages ? 'disabled' : ''}
          onclick="usuariosView.cambiarPagina(${page + 1})"
        >
          Siguiente →
        </button>
      </div>
      <div class="pagination-info">
        Mostrando ${this.data.usuarios.length} de ${total} usuarios
      </div>
    `;
  },

  cambiarPagina(page) {
    this.data.pagination.page = page;
    this.cargarUsuarios();
  },

  limpiarFiltros() {
    this.data.filters = { search: '', rol: '', activo: '' };
    this.data.pagination.page = 1;
    document.getElementById('searchInput').value = '';
    document.getElementById('rolFilter').value = '';
    document.getElementById('activoFilter').value = '';
    this.cargarUsuarios();
  },

  abrirModal(usuario = null) {
    this.data.editingUsuario = usuario;
    const modal = document.getElementById('usuarioModal');
    const title = document.getElementById('modalTitle');
    const form = document.getElementById('usuarioForm');
    const passwordInfo = document.getElementById('passwordInfo');
    const emailInput = document.getElementById('inputEmail');
    const usernameInput = document.getElementById('inputUsername');
    const tipoSelect = document.getElementById('inputTipoPersona');
    const bloqueFisica = document.getElementById('bloqueFisica');
    const bloqueMoral = document.getElementById('bloqueMoral');
    const groupTipo = document.getElementById('groupTipoPersona');
    const groupNombreEdit = document.getElementById('groupNombreCompletoEdit');

    form.reset();
    bloqueFisica.style.display = 'none';
    bloqueMoral.style.display = 'none';

    if (usuario) {
      // Modo edición — se oculta tipo_persona y se muestra nombre_completo readonly
      title.textContent = 'Editar Usuario';
      document.getElementById('inputUsername').value = usuario.username;
      document.getElementById('inputEmail').value = usuario.email || '';
      document.getElementById('inputRol').value = usuario.rol;
      // Normalizar teléfono legacy: quitar todo lo que no sea dígito y tomar últimos 10
      const telRaw = (usuario.telefono || '').replace(/\D/g, '');
      document.getElementById('inputTelefono').value = telRaw.slice(-10);
      document.getElementById('inputNombreCompletoEdit').value = usuario.nombre_completo || '';
      document.getElementById('labelNombreCompletoEdit').textContent =
        usuario.tipo_persona === 'moral' ? 'Razón social' : 'Nombre completo';
      // emailInput queda editable: el usuario puede cambiarlo / agregarlo / quitarlo
      emailInput.disabled = false;
      usernameInput.disabled = true;
      groupTipo.style.display = 'none';
      groupNombreEdit.style.display = '';
      tipoSelect.required = false;
      passwordInfo.style.display = 'none';
      document.getElementById('smsOptionWrap').style.display = 'none';
    } else {
      // Modo creación
      title.textContent = 'Nuevo Usuario';
      emailInput.disabled = false;
      usernameInput.disabled = false;
      groupTipo.style.display = '';
      groupNombreEdit.style.display = 'none';
      tipoSelect.disabled = false;
      tipoSelect.required = true;
      passwordInfo.style.display = 'block';
      document.getElementById('smsOptionWrap').style.display = 'block';
      document.getElementById('enviarSmsCheckbox').checked = true;
    }

    // Listener para mostrar/ocultar campos según tipo
    tipoSelect.onchange = () => {
      const tipo = tipoSelect.value;
      bloqueFisica.style.display = tipo === 'fisica' ? 'block' : 'none';
      bloqueMoral.style.display = tipo === 'moral' ? 'block' : 'none';
    };

    modal.style.display = 'flex';
  },

  cerrarModal() {
    const modal = document.getElementById('usuarioModal');
    modal.style.display = 'none';
    this.data.editingUsuario = null;
  },

  async guardarUsuario() {
    const btnGuardar = document.getElementById('btnGuardar');
    btnGuardar.disabled = true;
    btnGuardar.textContent = 'Guardando...';

    const esEdicion = !!this.data.editingUsuario;
    this._showProgress(esEdicion ? 'Actualizando usuario...' : 'Creando usuario...');

    try {
      const formData = {
        username: document.getElementById('inputUsername').value.trim(),
        email: document.getElementById('inputEmail').value.trim() || null,
        rol: document.getElementById('inputRol').value,
        telefono: document.getElementById('inputTelefono').value.trim() || null
      };

      if (esEdicion) {
        // Actualizar
        await usuarioService.update(this.data.editingUsuario.id, formData);
        this._hideProgress();
        window.toast.success('Usuario actualizado exitosamente');
      } else {
        // Crear: agregar datos de persona
        formData.tipo_persona = document.getElementById('inputTipoPersona').value;

        if (formData.tipo_persona === 'fisica') {
          formData.nombre = document.getElementById('inputNombreFisica').value.trim();
          formData.apellido_paterno = document.getElementById('inputApellidoPaterno').value.trim();
          formData.apellido_materno = document.getElementById('inputApellidoMaterno').value.trim();
        } else if (formData.tipo_persona === 'moral') {
          formData.razon_social = document.getElementById('inputRazonSocial').value.trim();
        }

        // Opción del admin: enviar (o no) la contraseña por SMS. Default: enviar.
        formData.enviar_sms = document.getElementById('enviarSmsCheckbox')?.checked !== false;

        this._showProgress('Validando datos...');
        const result = await usuarioService.create(formData);

        // Reflejar en el overlay según la opción elegida; luego mostrar la temp password.
        this._showProgress(formData.enviar_sms ? 'Enviando contraseña por SMS...' : 'Generando contraseña...');
        await new Promise(r => setTimeout(r, 300)); // breve pausa para que el usuario vea el cambio
        this._hideProgress();

        this.mostrarPasswordTemporal(result.tempPassword, result.sms);
      }

      this.cerrarModal();
      await this.cargarUsuarios();
      await this.cargarEstadisticas();
    } catch (error) {
      this._hideProgress();
      // Modal para 409 con duplicados detallados (email/tel/nombre coincidentes)
      if (error.status === 409 && error.details?.duplicados?.length) {
        this._mostrarModalDuplicado(error.details, esEdicion);
      } else if (error.status === 409) {
        // Modal genérico para otros conflictos (ej: "Esta persona ya tiene una cuenta de usuario")
        modal.open(
          esEdicion ? 'No se puede actualizar el usuario' : 'No se puede crear el usuario',
          `<p style="margin: 0;">${error.message || 'Conflicto al guardar.'}</p>`,
          [{ text: 'Entendido', class: 'btn-primary' }]
        );
      } else {
        window.toast.error(error.message || 'Error al guardar usuario');
      }
    } finally {
      btnGuardar.disabled = false;
      btnGuardar.textContent = 'Guardar';
    }
  },

  _mostrarModalDuplicado(details, esEdicion = false) {
    const camposStr = (details.campos_coincidentes || []).join(' y ');
    const titulo = esEdicion ? 'No se puede actualizar el usuario' : 'No se puede crear el usuario';

    const renderFieldHighlight = (label, value, matched) => {
      if (!value) return '';
      const style = matched
        ? 'background: #fff3cd; padding: 0.1rem 0.35rem; border-radius: 3px; color: #856404; font-weight: 600;'
        : '';
      const badge = matched ? ' <span style="font-size: 0.7rem; color: #856404;">← coincide</span>' : '';
      return `<div><strong>${label}:</strong> <span style="${style}">${value}</span>${badge}</div>`;
    };

    const filas = details.duplicados.map(d => {
      const matched = d.campos_que_coincidieron || [];
      return `
        <div style="border: 1px solid var(--gray-300); border-radius: 6px; padding: 0.75rem; margin-bottom: 0.5rem; background: var(--gray-50);">
          ${renderFieldHighlight('Nombre', d.nombre_completo, matched.includes('nombre'))}
          <div style="font-size: 0.85rem; color: var(--text-muted); margin-top: 0.3rem;">
            ${renderFieldHighlight('Email', d.email, matched.includes('email'))}
            ${renderFieldHighlight('Teléfono', d.telefono, matched.includes('teléfono'))}
          </div>
        </div>
      `;
    }).join('');

    modal.open(
      titulo,
      `
        <div style="background: #fff3cd; color: #856404; padding: 0.75rem 1rem; border-radius: 6px; margin-bottom: 1rem; border-left: 3px solid #f0ad4e;">
          Ya existe una persona con <strong>${camposStr}</strong> coincidente.
        </div>
        ${filas}
        <p style="margin-top: 1rem; font-size: 0.85rem; color: var(--text-muted);">
          Los campos resaltados son los que coinciden. Si crees que es otra persona diferente, ajusta los datos para diferenciarla.
        </p>
      `,
      [{ text: 'Entendido', class: 'btn-primary' }]
    );
  },

  async editarUsuario(id) {
    try {
      const response = await usuarioService.getById(id);
      this.abrirModal(response.usuario);
    } catch (error) {
      window.toast.error('Error al cargar usuario');
    }
  },

  async resetearPassword(id) {
    const usuario = (this.data.usuarios || []).find(u => u.id === id);
    const nombre = usuario?.nombre_completo || usuario?.username || 'este usuario';
    modal.confirm(
      'Resetear contraseña',
      `¿Está seguro de resetear la contraseña de <strong>${nombre}</strong>? Se generará una nueva contraseña temporal y se enviará por SMS.`,
      async () => {
        try {
          const result = await usuarioService.resetPassword(id);
          this.mostrarPasswordTemporal(result.tempPassword, result.sms);
          window.toast.success('Contraseña reseteada exitosamente');
        } catch (error) {
          window.toast.error(error.message || 'Error al resetear contraseña');
        }
      }
    );
  },

  async toggleActivo(id) {
    const usuario = (this.data.usuarios || []).find(u => u.id === id);
    const nombre = usuario?.nombre_completo || usuario?.username || 'este usuario';
    const accion = usuario?.activo ? 'desactivar' : 'activar';
    modal.confirm(
      'Cambiar estado del usuario',
      `¿Está seguro de ${accion} a <strong>${nombre}</strong>?`,
      async () => {
        try {
          const result = await usuarioService.toggleActive(id);
          const estado = result.usuario.activo ? 'activado' : 'desactivado';
          window.toast.success(`Usuario ${estado} exitosamente`);
          await this.cargarUsuarios();
          await this.cargarEstadisticas();
        } catch (error) {
          window.toast.error(error.message || 'Error al cambiar estado');
        }
      }
    );
  },

  async eliminarUsuario(id, nombre) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar al usuario <strong>${nombre}</strong>? Esta acción desactivará la cuenta.`,
      async () => {
        try {
          await usuarioService.delete(id);
          window.toast.success('Usuario eliminado exitosamente');
          await this.cargarUsuarios();
          await this.cargarEstadisticas();
        } catch (error) {
          window.toast.error(error.message || 'Error al eliminar usuario');
        }
      }
    );
  },

  mostrarPasswordTemporal(password, sms) {
    const modalEl = document.getElementById('passwordModal');
    const display = document.getElementById('tempPasswordDisplay');
    display.textContent = password;

    // Estado de envío del SMS
    const statusBox = document.getElementById('smsStatusDisplay');
    const helpText = document.getElementById('smsStatusHelp');
    if (statusBox && sms) {
      if (sms.enviado) {
        const tel = sms.telefono ? `${String(sms.telefono).slice(0, 3)}*****${String(sms.telefono).slice(-2)}` : '';
        statusBox.style.background = '#d4edda';
        statusBox.style.color = '#155724';
        statusBox.innerHTML = `<strong>SMS enviado</strong> al usuario ${tel ? `(${tel})` : ''}.`;
        statusBox.style.display = 'block';
        if (helpText) helpText.textContent = 'El usuario ya recibió la contraseña por SMS. Esta es una copia de respaldo.';
      } else {
        const omitido = sms.motivo && sms.motivo.includes('omitido');
        statusBox.style.background = omitido ? '#e2e3e5' : '#fff3cd';
        statusBox.style.color = omitido ? '#383d41' : '#856404';
        statusBox.innerHTML = omitido
          ? `<strong>SMS no enviado</strong> (por elección del administrador). Comparte la contraseña manualmente.`
          : `<strong>SMS NO enviado</strong>${sms.motivo ? ` (${sms.motivo})` : ''}. Comparte la contraseña manualmente.`;
        statusBox.style.display = 'block';
        if (helpText) helpText.textContent = 'Comunique esta contraseña al usuario de forma segura.';
      }
    } else if (statusBox) {
      statusBox.style.display = 'none';
    }

    modalEl.style.display = 'flex';
  },

  cerrarModalPassword() {
    const modalEl = document.getElementById('passwordModal');
    modalEl.style.display = 'none';
  },

  copiarPassword() {
    const password = document.getElementById('tempPasswordDisplay').textContent;
    navigator.clipboard.writeText(password).then(() => {
      window.toast.success('Contraseña copiada al portapapeles');
    }).catch(() => {
      window.toast.error('Error al copiar');
    });
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  }
};
